import ComplaintSubTypeDTO from "features/requirements/dtos/ComplaintSubTypeDTO";
import { FormValidations, SetValidationRuleFunction, ValidationActionType } from "features/shared/forms/hooks/useForm";
import { Nullable } from "features/shared/types/nullable";
import ValidationRule from "features/validation/rules/ValidationRule";

export const complaintFormInitValidations = (): FormValidations => {
  return {
    DESC_TMSMLOUVA: {
      required: true,
      type: "OnlyRequired"
    },
    DESC_TMKATEGREKLAM: {
      required: true,
      type: "OnlyRequired"
    },
    DESC_TMPODKATREKLAM: {
      required: true,
      type: "OnlyRequired"
    }
  };
}

export const setInvoiceValidation = (setValidationRule: SetValidationRuleFunction, complaintSubType: ComplaintSubTypeDTO) => {
  if (complaintSubType.invoiceEnable && complaintSubType.invoiceRequired) {
    const rule: ValidationRule = {
      required: true,
      type: "OnlyRequired"
    };
  
    setValidationRule("DESC_TMDOKLAD", rule);   
  } else {
    setValidationRule("DESC_TMDOKLAD", null, "remove");
  }
}